import { Control, FieldErrors } from 'react-hook-form';
import { IAccountSettings } from '../types';
import { ILookupNAICS, ILookupState } from '../../../_api';

export interface FieldProps {
    control: Control<IAccountSettings>;
    errors: FieldErrors<IAccountSettings>;
    readOnly?: boolean;
}

export const formatNaicsOptions = (options: Array<ILookupNAICS>) =>
    options.map(({ naics_code, naics_title }) => ({
        value: naics_code,
        label: `${naics_code} - ${naics_title}`
    }));

export const formatStateOptions = (options: Array<ILookupState>) =>
    options.map(({ state_code, state_name, country_code }) => ({
        value: state_code,
        label: `${state_code} - ${state_name} (${country_code})`
    }));
